import { BuyAdditionalContactsPropsInterface } from 'ui-addon-upgrades/_core/additionalContacts/BuyAdditionalContactsPropsInterface';
import ContactsConfirmationRedirectButton from 'ui-addon-upgrades/_core/additionalContacts/ContactsConfirmationRedirectButton';
import { CheckoutButtonPropsInterface } from 'ui-addon-upgrades/_core/checkout/CheckoutPropsInterface';
import { ContactSalesButtonPropsInterface } from 'ui-addon-upgrades/_core/contactSales/ContactSalesPropsInterface';
import * as PurchaseMotions from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { ViewAccountPropsInterface } from 'ui-addon-upgrades/_core/viewAccount/ViewAccountPropsInterface';
import UICheckoutButton from 'ui-addon-upgrades/button/UICheckoutButton';
import UIContactSalesButton from 'ui-addon-upgrades/button/UIContactSalesButton';
import UIRequestSeatButton from 'ui-addon-upgrades/button/UIRequestSeatButton/UIRequestSeatButton';
import { PricingPageRedirectButtonPropsInterface } from 'ui-addon-upgrades/button/interfaces/pricingPageRedirectButtonInterface';
import { AssignSeatButtonPropsInterface, RequestSeatButtonPropsInterface } from 'ui-addon-upgrades/button/interfaces/requestAssignSeatButtonInterface';
import UIAccountSummaryButton from '../../../button/UIAccountSummaryButton';
import UIAssignSeatButton from '../../../button/UIAssignSeatButton';
import UIPricingPageRedirectButton from '../../../button/UIPricingPageRedirectButton';
import UIRequestProductButton, { RequestProductPropsInterface } from '../../../button/UIRequestProductButton';
import UITrialActivationButton from '../../../button/UITrialActivationButton';
import AddAdditionalSeatsButton from '../../additionalSeats/AddAdditionalSeatsButton';
import { TrialActivationButtonPropsInterface } from '../../trial/TrialPropsInterface';
import { jsx as _jsx } from "react/jsx-runtime";
export const purchaseMotionKeys = Object.keys(PurchaseMotions).map(k => PurchaseMotions[k]);
export const purchaseMotionButtons = {
  [PurchaseMotions.BUY_TOUCHLESS]: UICheckoutButton,
  [PurchaseMotions.TALK_TO_SALES]: props => /*#__PURE__*/_jsx(UIContactSalesButton, Object.assign({}, props, {
    isAssignable: true
  })),
  [PurchaseMotions.TALK_TO_SALES_FALLBACK]: props => /*#__PURE__*/_jsx(UIContactSalesButton, Object.assign({}, props, {
    isAssignable: false
  })),
  [PurchaseMotions.TRIAL]: UITrialActivationButton,
  [PurchaseMotions.BUY_ADDITIONAL_SEATS]: AddAdditionalSeatsButton,
  [PurchaseMotions.BUY_ADDITIONAL_CONTACTS]: ContactsConfirmationRedirectButton,
  [PurchaseMotions.VIEW_ACCOUNT]: UIAccountSummaryButton,
  [PurchaseMotions.PRICING_PAGE_REDIRECT]: UIPricingPageRedirectButton,
  [PurchaseMotions.REQUEST_SEAT]: UIRequestSeatButton,
  [PurchaseMotions.ASSIGN_SEAT]: UIAssignSeatButton,
  [PurchaseMotions.REQUEST_ACCESS]: UIRequestProductButton
};
export const purchaseMotionButtonPropsInterface = {
  [PurchaseMotions.BUY_TOUCHLESS]: CheckoutButtonPropsInterface,
  [PurchaseMotions.TALK_TO_SALES]: ContactSalesButtonPropsInterface,
  [PurchaseMotions.TALK_TO_SALES_FALLBACK]: ContactSalesButtonPropsInterface,
  [PurchaseMotions.TRIAL]: TrialActivationButtonPropsInterface,
  [PurchaseMotions.BUY_ADDITIONAL_SEATS]: CheckoutButtonPropsInterface,
  [PurchaseMotions.BUY_ADDITIONAL_CONTACTS]: BuyAdditionalContactsPropsInterface,
  [PurchaseMotions.VIEW_ACCOUNT]: ViewAccountPropsInterface,
  [PurchaseMotions.PRICING_PAGE_REDIRECT]: PricingPageRedirectButtonPropsInterface,
  [PurchaseMotions.REQUEST_SEAT]: RequestSeatButtonPropsInterface,
  [PurchaseMotions.ASSIGN_SEAT]: AssignSeatButtonPropsInterface,
  [PurchaseMotions.REQUEST_ACCESS]: RequestProductPropsInterface
};
export const purchaseMotionData = ['currencyCode', 'productConfigurations', 'offerProductConfigurations', 'nonRecurringProductConfigurations', 'purchaseMotions', 'trialId'];